import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';
import { SmartSearchModel } from 'src/app/core/smartsearch/smartsearch';
import { MenuGroupSortOrderRequest } from '@royalty/model';

@Injectable()
export class GroupService extends HttpService {

	@POST('group/list')
	@Adapter(null, { isAdmin: true })
	getMenuGroups(@Body criteria: SmartSearchModel): Observable<any> {
		return null;
	}

	@GET('group/getbyid')
	@Adapter(null, { isAdmin: true })
	getMenuGroup(@Query('id') id: number): Observable<any> {
		return null;
	}

	@GET('group/getListSelection')
	@Adapter(null, { isAdmin: true })
	getListSelection(): Observable<any> {
		return null;
	}

	@GET('group/getvisiblegroup')
	@Adapter(null, { isAdmin: true })
	getVisiblegroup(): Observable<any> {
		return null;
	}

	@POST('group/create')
	@Adapter(null, { isAdmin: true })
	createMenuGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST('group/update')
	@Adapter(null, { isAdmin: true })
	updateMenuGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST('group/delete')
	@Adapter(null, { isAdmin: true })
	deleteMenuGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST('group/enable')
	@Adapter(null, { isAdmin: true })
	enableMenuGroup(@Body data: string): Observable<any> {
		return null;
	}
	@POST('group/disable')
	@Adapter(null, { isAdmin: true })
	disableMenuGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST('group/updateSortOrder')
	@Adapter(null, { isAdmin: true })
	updateSortOrder(@Body data: MenuGroupSortOrderRequest): Observable<any> {
		return null;
	}
}
